module.exports = __webpack_public_path__ + "static/media/happy_easter_important.d989596b.svg";